import { loader } from 'graphql.macro'

export default function serviceRequests ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const serviceRequestSchema = loader('./serviceRequests.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(serviceRequestSchema, {
    haulerId: variables.haulerId,
    statuses: variables.statuses || ['OPEN', 'PENDING_RESOLUTION']
  })
}
